/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScheduleWindow } from './scheduleWindow';

/**
 * A sequence's own concrete sending-window schedule.
 *
 * Org defaults are snapshot into the sequence at creation — there is NO
 * "use org defaults" toggle. Any field left ``None`` on create is filled
 * from the org's current outreach settings (the snapshot); thereafter the
 * sequence always uses its own values. When ``windows`` is provided it
 * must be the full 7-day set with at least one enabled day.
 */
export interface SequenceSchedule {
  timezone?: string | null;
  windows?: ScheduleWindow[] | null;
  skip_holidays?: boolean | null;
}
